import { createContext } from "react";

const auth = localStorage.getItem("auth") ? (JSON.parse(localStorage.getItem("auth") as any)) : {};
const authContext = createContext({
  authenticated: auth,
  setAuthenticated: (auth: any) => {}
});

export default authContext;
